import * as React from "react";
import { DeviceType } from "../../../../shared/api-clients/_api";
import "./sensor-descriptor.scss";

type Props = {
	deviceType: DeviceType.WRF04 | DeviceType.NOVOS3 | DeviceType.REGIN;
};

export const SensorDescriptor: React.FunctionComponent<Props> = ({ deviceType }) => {
	const sensors = {
		[DeviceType.WRF04]: {
			image: require("../../../assets/images/installer/peripherals/thermokon-wrf04.png"),
			title: "Temperature, CO2 & Humidity sensor - Thermokon WRF04",
		},
		[DeviceType.NOVOS3]: {
			image: require("../../../assets/images/installer/peripherals/novos-3-co2-sensor.jpg"),
			title: "Temperature, CO2 & Humidity sensor - Novos 3",
		},
		[DeviceType.REGIN]: {
			image: require("../../../assets/images/installer/peripherals/regin-co2-sensor.png"),
			title: "Regin CO2 sensor",
		},
	};
	const sensor = sensors[deviceType];
	return (
		<div className="sensor-descriptor">
			{/* rome-ignore lint/a11y/useAltText: <explanation> */}
			<img src={sensor.image} className="sensor-descriptor__image" />
			<p className="sensor-descriptor__peripheral" data-qa="sensor-descriptor-title">
				{sensor.title}
			</p>
		</div>
	);
};
